import { Box, Dropdown, DropdownItem } from '@amzn/ring-ui-react-components';
import { useMemo } from 'react';
import { DeviceSelectorDropdownIcon } from './DeviceSelectorDropdownIcon';
export interface Device {
  name: string;
  id: string;
  isRecordingEnabled: boolean;
  type: string;
}
export interface DeviceSelectorDropdownProps {
  devices: Array<Device>;
  onClick: (args: string) => void;
  selectedDevice: string;
  placeholder?: string;
}

export const DeviceSelectorDropdown = ({
  devices,
  selectedDevice,
  placeholder,
  onClick,
}: DeviceSelectorDropdownProps) => {
  const selectedDeviceObj = useMemo(
    () => devices.find((device) => device.id === selectedDevice),
    [devices, selectedDevice],
  );

  return (
    <Box mb={6}>
      <Dropdown
        value={selectedDevice || 'all-cameras'}
        placeholder={placeholder || 'All Cameras'}
        data-testid="device-selector-dropdown"
        width="100%"
        icon={
          <DeviceSelectorDropdownIcon
            type={selectedDeviceObj!.type}
            size={24}
          />
        }
      >
        {devices.map((device) => (
          <DropdownItem
            key={device.id}
            leftIcon={
              <DeviceSelectorDropdownIcon type={device.type} size={24} />
            }
            isSelected={selectedDevice === device.id}
            value={device.id}
            onClick={() => onClick(device.id)}
          >
            {device.name}
          </DropdownItem>
        ))}
      </Dropdown>
    </Box>
  );
};
